export const LOAD_OFFER_PARTNER_ELIGIBILITY_SUCCESS = "LOAD_OFFER_PARTNER_ELIGIBILITY_SUCCESS";
